import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M7 12a5 5 0 0 1 5 -5","key":"svg-2"}],["path",{"d":"M12 17a5 5 0 0 0 5 -5","key":"svg-3"}]]

const IconDisc = createReactComponent('outline', 'disc', 'Disc', __iconNode);

export default IconDisc;